import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Whatpeople = () => {
  const testimonials = [
    {
      // title: "",
      description:
        "I have had the pleasure of working closely with Dr. Vaibhav for last 8-9 years as a colleague in the HADSA management committee. Dr. Vaibhav is an exceptional professional who consistently demonstrates remarkable expertise and dedication in field of Scientific Nutrition. Zantus Lifesciences is an upcoming start-up founded by him and his technocrat colleague. I am sure customers will get conceptualized scientific nutritional products like ReduCarb from the innovative stable of Zantus.",
      imgSrc: "../assets/images/testimonials/ajit_singh.jpg",
      name: "Mr. Ajit Singh",
      position: "Chairman- ACG Group & President - HADSA",
    },
    {
      // title: "Top Quality, Best Products",
      description:
        "I tried the sample pack and must say it's a good easy replacement to one main meal. All the nutrients packed into a powder which is just to be dissolved and had like a shake….and you are totally full for the next 12-14hrs. Good weight management for us women's but would suggest a reduction in quantity for ladies as one pack is too filling.",
      imgSrc: "../assets/images/testimonials/preeti_arora.jpg",
      name: "Ms. Preeti Arora Bhowmick",
      position: "Housewife and Fitness Enthusiast",
    },
  ];

  const sliderSettings = {
    dots: true, // Enable dots
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="whatpeople-slider-section section-lg-space ratio_65">
      <div className="container-fluid-lg">
        <div className="text-center mb-3">
          <h2 className="center font_Home_section">What people say?</h2>
        </div>
        <div className="my-3">
          <Slider {...sliderSettings}>
            {testimonials.map((testimonial, index) => (
              <div key={index}>
                <div className="card-testimonial mt-4 mb-5 d-flex flex-column" style={{ minHeight: "550px" }}>
                  <h3 className="testimonial-title font-xmd my-3">
                    {testimonial.title}
                  </h3>
                  <p className="text-muted font-sm flex-grow-1">{testimonial.description}</p>
                  <div className="d-flex gap-3 align-items-center mt-auto">
                    <div className="testimonial-image-wrapper">
                      <img
                        src={testimonial.imgSrc}
                        className="testimonial-image"
                        alt={testimonial.name}
                      />
                    </div>
                    <div className="testimonial-info">
                      <h4 className="testimonial-name mb-2 color_green_head">
                        {testimonial.name}
                      </h4>
                      <h5 className="testimonial-position">
                        {testimonial.position}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Whatpeople;
